function sameProgramsSlider() {
	const $sliders = $('.js-same-programs');

	$sliders.each(function () {
		const $slider = $(this);
		const $btnPrev = $slider.closest('.js-same-programs-container').find('.js-same-programs-btn-prev');
		const $btnNext = $slider.closest('.js-same-programs-container').find('.js-same-programs-btn-next');

		const options = {
			slidesToShow: 3,
			arrows: false,
			dots: false,
			responsive: [{
				breakpoint: 1025,
				settings: {
					slidesToShow: 2,
					dots: true
				}
			},
			{
				breakpoint: 769,
				settings: {
					slidesToShow: 1,
					dots: true
				}
			},
			]
		};

		
		if ($slider.children().length >= 4) {
			$slider.slick(options);
		} else if ($slider.children().length < 4) {
			$slider.slick(options);

			$slider.find('.slick-track').addClass('slick-track_align');
			$btnPrev.hide();
			$btnNext.hide();
		}

		//$slider.slick(options);

		$btnPrev.on('click', function () {
			$slider.slick('slickPrev');
		});

		$btnNext.on('click', function () {
			$slider.slick('slickNext');
		});
	});
};

$(document).ready(sameProgramsSlider())